import type { FC } from "react";

import { cn } from "@/lib/utils";

import { workflowById } from "../catalog";
import { requiredViews, STATUS_META } from "../status";
import type { WorkflowStatus, WorkflowView } from "../types";

const ORANGE = "bg-orange dark:bg-warn";

const PIP: Partial<Record<WorkflowStatus, string>> = {
  done: "bg-success",
  running: "animate-pulse bg-fg-4",
  "needs-you": ORANGE,
  stale: ORANGE,
  failed: "bg-danger"
};

/** One segment per required workflow, in run order, colored by where it stands. */
export const ProgressPips: FC<{
  views: WorkflowView[];
  className?: string;
}> = ({ views, className }) => (
  <span className={cn("flex items-center gap-0.5", className)} aria-hidden>
    {requiredViews(views).map((v) => (
      <span
        key={v.id}
        title={`${workflowById(v.id).title}: ${STATUS_META[v.status].label}`}
        className={cn("h-1 w-3 rounded-full", PIP[v.status] ?? "bg-fill-3")}
      />
    ))}
  </span>
);
